export const sortConversationsPinnedFirst = (items = []) => (
  [...items].sort((a, b) => {
    if (Boolean(a.pinned) !== Boolean(b.pinned)) {
      return a.pinned ? -1 : 1;
    }
    const dateA = a.updatedAt instanceof Date
      ? a.updatedAt.getTime()
      : new Date(a.updatedAt || a.date || 0).getTime();
    const dateB = b.updatedAt instanceof Date
      ? b.updatedAt.getTime()
      : new Date(b.updatedAt || b.date || 0).getTime();
    return (Number.isFinite(dateB) ? dateB : 0) - (Number.isFinite(dateA) ? dateA : 0);
  })
);

export const normalizeConversationTitle = (value, maxLength = 60) => {
  const normalized = String(value || '').trim().replace(/\s+/g, ' ');
  return normalized.slice(0, maxLength);
};
